import React from 'react';
import './loader.scss';

const Loader = () => {
    return (
        <div id="loader-wrapper">
            <div className="loader" />
        </div>
    )
};

export default Loader;